var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"horizontal-resizer border-right border-500 my-1",class:{'horizontal-resizer-cursor': !_vm.resizeDisabled},on:{"mousedown":function($event){return _vm.onColResizerMouseDown($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }